import { render, staticRenderFns } from "./PowerCodeExplainerHead.vue?vue&type=template&id=e3333424&scoped=true"
import script from "./PowerCodeExplainerHead.vue?vue&type=script&lang=js"
export * from "./PowerCodeExplainerHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3333424",
  null
  
)

export default component.exports